module.exports = "/_next/static/images/fe47b0fe79d43b20ffb1d97a789ec4eb-cajitas-right-desktop.jpg";